import { render, staticRenderFns } from "./import_history.vue?vue&type=template&id=73712031&"
import script from "./import_history.vue?vue&type=script&lang=js&"
export * from "./import_history.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports